export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14340.2d366aa6.jpg";